import MainMenu from './MainMenu.js'
export default MainMenu;
